import {FilterOptionProps} from '../../MyTeamsContent.types';

export const getBonusFlags = (bonusOptions?: FilterOptionProps[]) => {
  const values = bonusOptions?.filter(o => o.selected).map(o => o.id) ?? [];

  return {
    cabEarned: values.includes('cabEarnedLastPeriod'),
    aabEarned: values.includes('aabEarnedLastPeriod'),
  };
};
